import React from 'react';
import { useAppSelector } from '../../../app/hooks';
import config from '../../../envConfig';
import { selectCarteiraDocumentos } from '../carteiraDocumentosSlice';
import { useUploadCordova } from './useUploadCordova';
import { useUploadWeb } from './useUploadWeb';
import styles from './UploadDocumento.module.css';

const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const UploadDocumento: React.FC = () => {
  const dados = useAppSelector(selectCarteiraDocumentos);
  const isCordova = config.isCordova && !!window.cordova;

  const cordova = useUploadCordova();
  const web = useUploadWeb();

  const loading = isCordova ? cordova.loading : false;
  const handleSelecionarGaleria = isCordova ? cordova.handleSelecionarGaleria : web.handleSelecionarGaleria;
  const handleTirarFoto = isCordova ? cordova.handleTirarFoto : web.handleTirarFoto;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.integranteNome}>{dados.integranteNome}</h2>
        <p className={styles.tipoDocumento}>{dados.nomeDocumento}</p>
      </div>

      <div className={styles.opcoesContainer}>
        <button
          className={`${styles.opcaoButton} ${loading ? styles.opcaoButtonDisabled : ''}`}
          onClick={handleSelecionarGaleria}
          disabled={loading}
        >
          <div className={styles.opcaoIcon}>
            <i className={loading ? 'fas fa-spinner fa-spin' : 'fas fa-images'}></i>
          </div>
          <div className={styles.opcaoContent}>
            <span className={styles.opcaoTitulo}>Selecionar da galeria</span>
            <span className={styles.opcaoSubtitulo}>Selecione fotos em formato PNG, JPG ou JPEG de até 2 MB</span>
          </div>
        </button>

        {(isCordova || isMobileDevice) && (
          <button
            className={`${styles.opcaoButton} ${loading ? styles.opcaoButtonDisabled : ''}`}
            onClick={handleTirarFoto}
            disabled={loading}
          >
            <div className={styles.opcaoIcon}>
              <i className={loading ? 'fas fa-spinner fa-spin' : 'fas fa-camera'}></i>
            </div>
            <div className={styles.opcaoContent}>
              <span className={styles.opcaoTitulo}>Tirar foto do documento</span>
              <span className={styles.opcaoSubtitulo}>Use a câmera do seu celular para enviar fotos de até 2MB</span>
            </div>
          </button>
        )}
      </div>

      {!isCordova && (
        <input
          ref={web.fileInputRef}
          type="file"
          style={{ display: 'none' }}
          onChange={web.handleFileChange}
        />
      )}
    </div>
  );
};

export default UploadDocumento;
